import NP from 'number-precision'
import { round } from 'lodash'
/**
 * 获取薪资单位.
 * @param {*} type
 * @param {*} bool
 */
export const salaryType = (type, bool) => {
  if (!bool) {
    return { '1': '万元以上/年', '2': '以上/月', '3': '元以上/日', '4': '元以上/小时' }[type]
  }
  return { '1': '万元/年', '2': '/月', '3': '元/日', '4': '元/小时' }[type]
}
/**
 * 薪资映射.
 */
export const salaryTypeField = {
  '1': { begin: 'annual_salary_begin', end: 'annual_salary_end' },
  '2': { begin: 'monthly_salary_begin', end: 'monthly_salary_end' },
  '3': { begin: 'daily_salary_begin', end: 'daily_salary_end' },
  '4': { begin: 'hourly_salary_begin', end: 'hourly_salary_end' }
}
export const numFormat = (num, type) => {
  if (num === undefined) return 0
  if (Number(type) !== 2) return num
  const numFix = (Number(num) / 1000).toFixed(1)
  const arr = String(numFix).split('.')
  if (+arr[0] === 0 && +arr[1] === 0) return 0
  if (+arr[0] > 0 && +arr[1] === 0) return `${arr[0]}k`
  return `${numFix}k`
}

/**
 * @description 将薪资数字从"分"转为"元"后,分别就年薪、月薪或时薪进行薪资格式处理
 * @param       {Number|String} begin
 * @param       {Number|String} end
 * @param       {String} type
 * @returns     {String|Number}
 */
export const calculateSalary = (begin = 0, end = 0, type) => {
  let transformStart = NP.divide(Number(begin), 100)
  let transformEnd = NP.divide(Number(end), 100)
  if (Number(type) === 1) {
    transformStart = round(NP.divide(transformStart, 10000), 1)
    transformEnd = round(NP.divide(transformEnd, 10000), 1)
  }
  const formatStart = numFormat(transformStart, type)
  const formatEnd = numFormat(transformEnd, type)
  if (formatStart === formatEnd) {
    return formatStart
  }
  return `${formatStart}${formatEnd ? `-${formatEnd}` : ''}`
}

export const formatIndustry = industries => {
  const results = industries.map(x => x.name)
  return results.join('、')
}
/**
 * 根据环境返回图片地址域名
 */
export const getPicOrigin = () => {
  const isDev = window.location.href.indexOf('.testing.zhilingyun.net') > -1
  const imgHost = isDev ? '//uimg.testing2.ifchange.com' : '//uimg.ifchange.com'
  return imgHost
}

/**
 * /employee-detail/312?tab=list&current=2&pageSize=10 => %2Femployee-detail%2F312%3Ftab%3Dlist%26current%3D2%26pageSize%3D10
 */

export function encodeUrlSearch() {
  const { pathname, search } = window.location
  if (encodeURIComponent) {
    return encodeURIComponent(`${pathname}${search}`)
  }
  return ''
}

/**
 * encodeUrlSearch 相反的方法
 */
export function decodeUrlSearch(str) {
  if (decodeURIComponent) {
    return decodeURIComponent(str)
  }
  return ''
}

/**
 * 请输入有效的手机号
 */

export function isTel(val) {
  return /^1[0-9]{10}$/.test(val)
}

export function isEmail(val) {
  return /^([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(val)
}
